// extracted by mini-css-extract-plugin
export default {"link":"Charters_link__y+2m4","container":"Charters_container__o+OKl"};